import { Grid, Typography } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { BaseButton } from 'src/common/components/base-button';
import { vh } from 'src/common/helpers/dimension-helper';
import CashierPreferencesHelper from '../../common/helpers/cashier-preferences-helper';
import { getDescriptionAccordingToStoreCulture } from '../../common/helpers/localized-description-helper';
import { IDepartment } from '../../common/interfaces/dtos/IDepartment';
import Pagination from '../../pagination/pagination';
import { departmentSaleStyles } from './department-sale-styles';
import { useTranslation } from 'react-i18next';

const DepartmentSaleList: React.FC<DepartmentSaleListProps> = (
  props: DepartmentSaleListProps,
): JSX.Element => {
  const classes = departmentSaleStyles();
  const { t } = useTranslation();
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();
  const MAX_DEPARTMENTS_VISIBLE = 20;
  const totalPages = Math.ceil(props.departments.length / MAX_DEPARTMENTS_VISIBLE);
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = useCallback(
    (page: number) => {
      setCurrentPage(page);
    },
    [setCurrentPage],
  );

  return (
    <Grid item container direction='column' style={{ flex: 1 }} data-testid='department-sale-list'>
      <Grid
        item
        container
        direction='column'
        style={isLeftHanded ? { flex: 1, marginLeft: '10px' } : { flex: 1 }}
      >
        <Grid item style={{ paddingTop: '5.77vh', height: 'fit-content' }}>
          <Typography className={classes.selectDepartmentSubheading}>Select Department</Typography>
        </Grid>
        <Grid item container className={classes.departmentCardContainer}>
          {props.departments &&
            props.departments
              .slice(
                (currentPage - 1) * MAX_DEPARTMENTS_VISIBLE,
                currentPage * MAX_DEPARTMENTS_VISIBLE,
              )
              .map(d => {
                return (
                  <Grid
                    item
                    container
                    direction='column'
                    alignItems='center'
                    justifyContent='space-between'
                    key={d.departmentId}
                    className={classes.departmentCard}
                    onClick={() => props.onDepartmentSelected(d.departmentId)}
                    data-testid={`department-card-${d.departmentId}`}
                  >
                    <Typography className={classes.departmentCardHeader}>
                      {getDescriptionAccordingToStoreCulture(d.descriptions)}
                    </Typography>
                    <Typography className={classes.departmentCardSubheader}>
                      {d.departmentId}
                    </Typography>
                  </Grid>
                );
              })}
        </Grid>
      </Grid>
      <Grid item container justifyContent='space-between' className='fullWidth'>
        <Grid item container style={{ width: 'auto' }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            updateCurrentPageHandler={handlePageChange}
            testIdPrefix={'department-sale'}
          />
        </Grid>
        <Grid item container justifyContent='center' style={{ width: 'auto' }}>
          <BaseButton
            style={{ fontSize: vh(2.1248) }}
            buttonType='white'
            onClick={props.onCancel}
            data-testid='department-sale-cancel-button'
          >
            {t('Cancel')}
          </BaseButton>
        </Grid>
        <Grid style={{ width: '10vh' }} />
      </Grid>
    </Grid>
  );
};

interface DepartmentSaleListProps {
  departments: IDepartment[];
  onDepartmentSelected: (departmentId: string) => void;
  onCancel: () => void;
}

export default DepartmentSaleList;
